import { Component, Inject, OnInit, Optional } from '@angular/core';
import { CreateNewPatientModalService } from './create-new-patient-modal.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import {
    MatDialogRef,
    MAT_DIALOG_DATA,
    MatDialog,
} from '@angular/material/dialog';
import * as moment from 'moment';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { DisallowSpacesDirective } from '../../../../directive/disallow-spaces.directive';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {
    callSourceArray,
    carrierTypeArray,
    checkExternalIdExistsOrNot,
    checkExternalIdExistsPayload,
    createNewPatient,
    DateOfBirthObject,
    genderArray,
    leadSourceArray,
    medicarePrescriptionPaymentPlanArray,
    months,
    patientInformationObject,
    preferredApptReminderMethodArray,
    relationshipArray,
    salutationArray,
} from './create-new-patient-interfaces';
import { NgSelectModule } from '@ng-select/ng-select';
import { InboxService } from '../../inbox/inbox.service';
import { PatientDetailMergeModalComponent } from '../patient-details-merge-modal/patient-detail-merge-modal.component';
import { CustomPatientLabelPipe } from '../../pipes/patient-label.pipe';
import { Subscription } from 'rxjs';
import { ApisService } from 'src/app/services/apis.service';
import { getCodeValueByCategoryIdResult } from '../patients-interface';
import { HttpErrorResponse } from '@angular/common/http';
import { reservedCodeCategories } from 'admin-ui-v2-config';
import { LocalServiceService } from 'src/app/services/local-service.service';

@Component({
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ToastrModule,
        MatSelectModule,
        DisallowSpacesDirective,
        MatInputModule,
        MatAutocompleteModule,
        NgSelectModule,
        CustomPatientLabelPipe,
    ],
    selector: 'app-create-new-patient-modal',
    templateUrl: './create-new-patient-modal.component.html',
    styleUrls: ['./create-new-patient-modal.component.css'],
})
export class CreateNewPatientModalComponent implements OnInit {
    genderArr: { value: string; label: string }[] = [
        { value: 'MALE', label: 'Male' },
        { value: 'FEMALE', label: 'Female' },
    ];
    __temporaryPassword: number | null = null;
    isValid: boolean = true;
    emailRegex: RegExp = /^[\S]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    nameRegex: RegExp = /^[A-Za-z0-9 ]+$/;
    phoneRegex: RegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
    deformatPhoneRegex: RegExp = /[^A-Za-z0-9]+/g;
    tempPhone: string = '';
    email: string = '';
    loader: boolean = false;
    checkExternalIdExistsOrNot: checkExternalIdExistsOrNot = {
        data: {
            isSameOrgEntity: false,
            isExternalIdAlreadyPresent: false,
            newOrgEntityId: '',
            isNew: false,
        },
        isActionSuccess: false,
    };
    patientInformationObject: patientInformationObject = {
        patientInfo: {
            isIndividual: true,
            type: 'PATIENT',
            displayName: '',
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            gender: '',
            externalId: '',
            homePhone: '',
            cellPhone: '',
            email: '',
            callSource: '',
            leadSource: '',
            healthPlan: '',
            memberId: '',
            language: '',
            address: {
                addressLine1: '',
                addressLine2: '',
                city: '',
                postalCode: '',
                stateOrProvinceCode: null,
            },
        },
    };
    dateOfBirthObject: DateOfBirthObject = {
        dateOfBirth: '',
        dobMonth: null,
        dobYear: '',
        dobDay: null,
    };
    getCodeValueByCategoryIdAddressTimezone: Subscription = new Subscription();
    addressTimezone: any[] = [];
    patientCreationModelMap: any = {};
    leadSourceArray: any[] = [];
    callSourceArray = callSourceArray;
    salutationArray = salutationArray;
    genderArray = genderArray;
    relationshipArray = relationshipArray;
    healthPlanArray: any[] = [];
    languageArray: any[] = [];
    timezoneArray: any[] = [];
    leadStatusArray: any[] = [];
    preferredApptReminderMethodArray = preferredApptReminderMethodArray;
    carrierTypeArray = carrierTypeArray;
    medicarePrescriptionPaymentPlanArray = medicarePrescriptionPaymentPlanArray;
    formData: any = {};
    categoryIds: any[] = [];
    patientDetailsAddObj: any;
    constructor(
        public createNewPatientService: CreateNewPatientModalService,
        private toastr: ToastrService,
        public dialog: MatDialog,
        private localService: LocalServiceService,
        public dialogRef: MatDialogRef<CreateNewPatientModalService>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            showBackToSearch: boolean;
            patientDetails: any;
            editPatient: boolean;
            stateList: any[];
            orgEntityId?: string;
            patientAdditionalFields: any;
            additionalDetailsEmittedValue: any;
        },
        public api: ApisService,
    ) {}
    day: string = '';
    days: string[] = [];
    months = months;
    isPatientCreationModelEnabled = false;
    setDays() {
        for (let j = 0; j < this.months.length; j++) {
            if (
                this.months[j].id == this.dateOfBirthObject.dobMonth?.toString()
            ) {
                this.days = []; // Reset days array before adding new days
                for (let i = 1; i <= this.months[j].maxDays; i++) {
                    if (i < 10) {
                        this.day = '0' + i;
                        this.days.push(this.day.toString());
                    } else {
                        this.days.push(i.toString());
                    }
                }
            }
        }
    }
    checkNumber(event: any) {
        /**check the value of the keyPress to make sure it's a num. which from 48-57 are 0-9 */
        if ((event.which !== 8 && event.which < 48) || event.which > 57) {
            event.preventDefault();
        }
    }

    checkIfDateOfBirthIsGreaterThanCurrentDate(enteredDateOfBirth: any) {
        enteredDateOfBirth = new Date(enteredDateOfBirth);
        enteredDateOfBirth.setHours(0, 0, 0, 0);
        var currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        return enteredDateOfBirth >= currentDate;
    }
    closeModal() {
        this.dialogRef.close({ goBackToSearch: false });
    }
    monthName(value1: string) {
        if (value1) {
            if (this.months?.find((month) => month.id === value1)) {
                return this.months?.find((month) => month.id === value1)
                    ?.displayName;
            }
        }
        return null;
    }
    removeAllSpace() {
        setTimeout(() => {
            this.patientInformationObject.patientInfo.externalId =
                this.patientInformationObject.patientInfo.externalId.replaceAll(
                    /\s/g,
                    '',
                );
        }, 0);
    }
    validatePatientInfoExtendedInfo() {
        this.isValid = true;
        const isDOBRequired = this.isRequired('dateOfBirth');
        let isLeapYear =
            parseInt(this.dateOfBirthObject.dobYear) % 100 === 0
                ? parseInt(this.dateOfBirthObject.dobYear) % 400 === 0
                : parseInt(this.dateOfBirthObject.dobYear) % 4 === 0;
        if (
            this.patientCreationModelMap &&
            this.isPatientCreationModelEnabled &&
            this.patientCreationModelMap.length > 0
        ) {
            for (const field of this.patientCreationModelMap) {
                 
                if (field.required) {
                 
                    let value: any;
                    if (field.label === 'timezone') {
                        value =
                            this.patientInformationObject.patientInfo.address
                                ?.timezone;
                    } else if (field.label === 'preferredLanguage') {
                        value =
                            this.patientInformationObject.patientInfo.language;
                    } else if (field.label === 'patientId') {
                        value =
                            this.patientInformationObject.patientInfo.externalId;
                    } else if (field.label === 'dateOfBirth') {
                        value =
                             this.dateOfBirthObject?.dobMonth &&
                                    this.dateOfBirthObject?.dobDay &&
                                    this.dateOfBirthObject?.dobYear
                                        ? `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
                                        : null
                    }  else if (field.label === 'address') {
                        const address = this.patientInformationObject.patientInfo.address;
                        const requiredAddressFields = [
                            'addressLine1',
                            'city',
                            'postalCode',
                            'stateOrProvinceCode'
                        ];
                        const isAddressInvalid =
                            !address ||
                            requiredAddressFields.some(
                                key =>
                                    !address[key] ||
                                    (typeof address[key] === 'string' &&
                                        !address[key].trim())
                            );
                        if (isAddressInvalid) {
                            this.toastr.warning(`Street, city, state and zip code are mandatory fields for address`);
                            this.isValid = false;
                        }
                    } else {
                        value =
                            this.patientInformationObject.patientInfo[
                                field.label as keyof typeof this.patientInformationObject.patientInfo
                            ];
                    }
                    if ((field.label !== 'address' && field.label !== 'dateOfBirth') &&
                        !value ||
                        (typeof value === 'string' && !value.trim())
                    ) {
                        this.toastr.warning(
                            `Please enter ${field.displayName}`,
                        );
                        this.isValid = false;
                    }
                }
            }
        }
        if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.externalId.length > 100
        ) {
            this.toastr.warning(
                `External Id should be less than 100 characters`,
            );
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.firstName.length > 60
        ) {
            this.toastr.warning(`First name should be less than 60 characters`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.lastName.length > 60
        ) {
            this.toastr.warning(`Last name should be less than 60 characters`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.homePhone &&
            (this.patientInformationObject.patientInfo.homePhone.length !==
                15 ||
                !this.phoneRegex.test(
                    this.patientInformationObject.patientInfo.homePhone,
                ))
        ) {
            this.toastr.warning(`Please enter valid Home Phone Number`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.cellPhone &&
            (this.patientInformationObject.patientInfo.cellPhone.length !==
                15 ||
                !this.phoneRegex.test(
                    this.patientInformationObject.patientInfo.cellPhone,
                ))
        ) {
            this.toastr.warning(`Please enter valid Cell Phone Number`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.email &&
            !this.emailRegex.test(
                this.patientInformationObject.patientInfo.email,
            )
        ) {
            // if (!this.emailRegex.test(this.patientInformationObject.patientInfo.emailAddresses[0].email)) {
            this.toastr.warning(`Enter a valid Confidential Email`);
            this.isValid = false;
            // }
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.email.length > 100
        ) {
            this.toastr.warning(
                `Email address should be less than 100 characters`,
            );
            this.isValid = false;
        }  else if (this.isPatientCreationModelEnabled === true && this.dateOfBirthObject) {
            const { dobMonth, dobDay, dobYear } = this.dateOfBirthObject;
            const isAnyDobFilled = !!(dobMonth || dobDay || dobYear);
            const isAllDobFilled = !!(dobMonth && dobDay && dobYear);
            if (isDOBRequired && !isAllDobFilled) {
                if (!dobMonth) {
                    this.toastr.warning('Please enter your DOB Month');
                } else if (!dobDay) {
                    this.toastr.warning('Please enter your DOB Day');
                } else if (!dobYear) {
                    this.toastr.warning('Please enter your DOB Year');
                }
                this.isValid = false;
            }
            if (!isDOBRequired && isAnyDobFilled && !isAllDobFilled) {
                if (!dobMonth) {
                    this.toastr.warning('Please enter your DOB Month');
                } else if (!dobDay) {
                    this.toastr.warning('Please enter your DOB Day');
                } else if (!dobYear) {
                    this.toastr.warning('Please enter your DOB Year');
                }
                this.isValid = false;
            }
    } else if (
            this.isValid &&
            this.dateOfBirthObject.dobMonth &&
            this.dateOfBirthObject.dobDay &&
            this.dateOfBirthObject.dobYear
        ) {
            if (
                this.dateOfBirthObject.dobMonth < 10 &&
                this.dateOfBirthObject.dobDay >= 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            } else if (
                this.dateOfBirthObject.dobDay < 10 &&
                this.dateOfBirthObject.dobMonth >= 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            } else if (
                this.dateOfBirthObject.dobDay < 10 &&
                this.dateOfBirthObject.dobMonth < 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            } else {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            }
            var date = moment(
                this.patientInformationObject.patientInfo.dateOfBirth,
            );
            if (date.isValid()) {
                var currentDateTime = new Date();
                var expirationDateTime = new Date(
                    this.patientInformationObject.patientInfo.dateOfBirth,
                );
                if (expirationDateTime.getTime() > new Date().getTime()) {
                    this.toastr.warning(
                        "Birth date can't be greater than or equal to the current date",
                    );
                    this.isValid = false;
                } else if (+this.dateOfBirthObject.dobYear < 1900) {
                    this.toastr.warning(
                        'Birth year should be greater than or equal to 1900.',
                    );
                    this.isValid = false;
                } else if (
                    expirationDateTime.getMonth() ===
                        currentDateTime.getMonth() &&
                    expirationDateTime.getFullYear() ===
                        currentDateTime.getFullYear() &&
                    expirationDateTime.getDate() === currentDateTime.getDate()
                ) {
                    this.toastr.warning(
                        "Birth date can't be greater than or equal to the current date",
                    );
                    this.isValid = false;
                } else if (
                    this.dateOfBirthObject.dobMonth.toString() == '02' &&
                    this.dateOfBirthObject.dobDay > 28 &&
                    !isLeapYear
                ) {
                    this.toastr.warning('Invalid birth date');
                    this.isValid = false;
                } else {
                    this.isValid = true;
                }
            } else {
                this.toastr.warning('Date of birth is invalid');
                this.isValid = false;
            }
        }
         if (
            this.patientInformationObject.patientInfo?.address?.postalCode &&
            this.patientInformationObject.patientInfo.address.postalCode.trim() !== '' &&
            (
                this.patientInformationObject.patientInfo.address.postalCode.trim().length < 5 ||
                this.patientInformationObject.patientInfo.address.postalCode.trim().length > 5
            )
        ) {
             this.toastr.warning(`Zip Code must be 5 digits`);
            this.isValid = false;
        }

        return this.isValid;
    }
    formatNumber() {
        this.formatPhoneNumberAndValidate();
    }
    formatPhoneNumberAndValidate() {
        this.patientInformationObject.patientInfo.homePhone =
            this.cleanPhoneNumber(
                this.patientInformationObject.patientInfo.homePhone,
            );
        this.patientInformationObject.patientInfo.cellPhone =
            this.cleanPhoneNumber(
                this.patientInformationObject.patientInfo.cellPhone,
            );
          if (
        this.data &&
        this.data.patientAdditionalFields &&
        Array.isArray(this.data.patientAdditionalFields.columns)
    ) {
        for (const col of this.data.patientAdditionalFields.columns) {
            const type = (col.type || '').toString().toUpperCase();
            const prop = col.dataProperty;
            if (
                prop &&
                (type === 'NUMERIC(PHONE)')
            ) {
                const raw = this.formData[prop];
                if (raw) {
                    this.formData[prop] = this.cleanPhoneNumber(raw);
                } else {
                    this.formData[prop] = '';
                }
            }
        }
    }
    }
    filterPhoneNumber = (phoneNumber: string) => {
        if (!phoneNumber) {
            return '';
        }
        var value = phoneNumber.toString().trim().replace(/^\+/, '');
        if (value.match(/[^0-9]/)) {
            return phoneNumber;
        }
        var country,
            city,
            number = value;
        if (number) {
            if (number.length > 6) {
                number =
                    number.slice(0, 3) +
                    '-' +
                    number.slice(3, 6) +
                    '-' +
                    number.slice(6, 10);
            } else if (number.length > 3) {
                number = number.slice(0, 3) + '-' + number.slice(3, 6);
            }
            return ('+1 ' + number).trim();
        } else {
            return '+1 ' + number;
        }
    };

    cleanPhoneNumber(phone: string): string {
        if (!phone) return '';

        phone = phone.replace(/-/g, '');

        if (phone.includes('+')) {
            phone = phone.slice(3);
        }

        return this.filterPhoneNumber(phone);
    }
    formatPhoneNumber(phone: string): string {
        if (!phone) return '';
        let digits = phone.replace(/\D/g, '');
        if (digits.length === 11 && digits.startsWith('1')) {
            digits = digits.slice(1);
        }
        digits = digits.slice(0, 10);
        return digits;
    }
    createPatientInformation() {
        if (this.validatePatientInfoExtendedInfo()) {
            this.patientDetailsAdd()
            var checkObject: checkExternalIdExistsPayload = {
                externalId: '',
            };
            if (!this.__temporaryPassword) {
                this.__temporaryPassword = Math.floor(
                    100000 + Math.random() * 900000,
                );
            }
            checkObject.externalId =
                this.patientInformationObject.patientInfo.externalId;

            if (this.isPatientCreationModelEnabled == true && checkObject.externalId && checkObject.externalId.length > 0) {
                this.createNewPatientService
                    .checkExternalIdAlreadyExistsOrNot(checkObject)
                    .then((result: any) => {
                        if (result && result.data) {
                            const checkResult: checkExternalIdExistsOrNot = {
                                data: result.data,
                                isActionSuccess: result.isActionSuccess,
                            };
                            if (
                                checkResult &&
                                checkResult.data &&
                                checkResult.data.isExternalIdAlreadyPresent
                            ) {
                                this.toastr.warning(
                                    'External Id already exists, please enter another one.',
                                );
                            } else if (
                                checkResult &&
                                checkResult.data &&
                                !checkResult.data.isExternalIdAlreadyPresent
                            ) {
                                this.createPatient();
                            }
                        }
                    })
                    .catch((error: any) => {
                        console.log(error);
                        this.toastr.error(
                            error.error?.message ||
                                error?.error?.Error ||
                                'Unknown error occurred. Please contact administrator.',
                        );
                    });
            }else{
                this.createPatient();
            }
        }
    }

    patientDetailsAdd(){
         this.patientInformationObject.patientInfo.cellPhone =
                                    this.cleanPhoneNumber(
                                        this.patientInformationObject
                                            .patientInfo.cellPhone,
                                    );
                                this.patientInformationObject.patientInfo.homePhone =
                                    this.cleanPhoneNumber(
                                        this.patientInformationObject
                                            .patientInfo.homePhone,
                                    );
        this.patientDetailsAddObj = this.cleanObject({
                                    externalId:
                                        this.patientInformationObject
                                            .patientInfo.externalId,
                                    firstName:
                                        this.patientInformationObject
                                            .patientInfo.firstName,
                                    lastName:
                                        this.patientInformationObject
                                            .patientInfo.lastName,
                                    dateOfBirth:
                                    this.dateOfBirthObject?.dobMonth &&
                                    this.dateOfBirthObject?.dobDay &&
                                    this.dateOfBirthObject?.dobYear
                                        ? `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
                                        : null,
                                    gender: this.patientInformationObject
                                        .patientInfo.gender,
                                    cellPhone: this.formatPhoneNumber(
                                        this.patientInformationObject
                                            .patientInfo.cellPhone,
                                    ),
                                    homePhone: this.formatPhoneNumber(
                                        this.patientInformationObject
                                            .patientInfo.homePhone,
                                    ),
                                    email: this.patientInformationObject
                                        .patientInfo.email,
                                    address:
                                        this.patientInformationObject
                                            .patientInfo.address,
                                    healthPlan:
                                        this.patientInformationObject
                                            .patientInfo.healthPlan,
                                    memberId:
                                        this.patientInformationObject
                                            .patientInfo.memberId,
                                    language:
                                        this.patientInformationObject
                                            .patientInfo.language,
                                    leadSource:
                                        this.patientInformationObject
                                            .patientInfo.leadSource,
                                    callSource:
                                        this.patientInformationObject
                                            .patientInfo.callSource,
                                });
    }

    createPatient(){
          this.createNewPatientService
                                    .createNewPatient(this.patientDetailsAddObj)
                                    .then((resultData: any) => {
                                        if (resultData) {
                                            const result: createNewPatient = {
                                                data: resultData.data,
                                                isAlreadyPresent:
                                                    resultData.isActionSuccess,
                                            };
                                            this.toastr.success(
                                                'Member created successfully.',
                                            );
                                            if (this.showBackToSearchBtn)
                                                this.dialogRef.close({
                                                    associateWithNewPatient:
                                                        result,
                                                });
                                            else this.dialogRef.close(true);
                                        }
                                    })
                                    .catch((ex: any) => {
                                        console.log(ex);
                                        this.toastr.error(
                                            ex.error?.message ||
                                                ex?.error?.Error ||
                                                'Unknown error occurred. Please contact administrator.',
                                        );
                                    });
    }

    // Only AlphaNumeric
    keyPressAlphaNumeric(event: any , type?: string) {
        var inp = String.fromCharCode(event.keyCode);
        if (type === 'number') {
            if (/^[0-9]$/.test(inp)) {
                return true;
            } else {
                event.preventDefault();
                return false;
            }
        }
        if (/^[a-zA-Z0-9]+$/.test(inp)) {
            return true;
        }else if(type == 'alphanumeric' && (/^[a-zA-Z0-9 ]+$/.test(inp))){
             return true;
        }else if(type == 'alpha' && (/^[a-zA-Z ]$/.test(inp))){
             return true;
        } else {
            event.preventDefault();
            return false;
        }
    }

    backToSearch() {
        this.dialogRef.close({ goBackToSearch: true });
    }
    onPaste(event: ClipboardEvent, type?: string) {
        event.preventDefault();
        let pastedText = event.clipboardData?.getData('text/plain') || '';
        let digits = pastedText.replace(/\D/g, '');
        if (digits.length === 11 && digits.startsWith('1')) {
            digits = digits.slice(1);
        }
        digits = digits.slice(0, 10);
        let formatted = '';
        if (digits.length === 10) {
            formatted = `+1 ${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
        } else {
            formatted = `+1 ${digits}`;
        }
        const input = event.target as HTMLInputElement;
       
         if (type === 'number') {
            let digits = pastedText.replace(/\D/g, ''); 
            digits = digits.slice(0, 5);
            input.value = digits;
        }else{
            input.value = formatted;
        }
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    showBackToSearchBtn: boolean = true;
    ngOnInit(): void {
        if (this.data && this.data.showBackToSearch) {
            this.showBackToSearchBtn = true;
        }
        if (this.data.patientDetails) {
            const patientFullName = this.data.patientDetails.patientName
                .trim()
                .split(' ');
            this.patientInformationObject.patientInfo.firstName =
                this.data.patientDetails.firstName || '';
            this.patientInformationObject.patientInfo.middleName =
                this.data.patientDetails.middleName || '';
            this.patientInformationObject.patientInfo.lastName =
                this.data.patientDetails.lastName || '';
            if (this.data.patientDetails.dateOfBirth) {
                const [month, day, year] =
                    this.data.patientDetails.dateOfBirth.split('/');
                this.dateOfBirthObject.dobMonth = month;
                this.setDays();
                this.dateOfBirthObject.dobDay = day;
                this.dateOfBirthObject.dobYear = year;
                this.patientInformationObject.patientInfo.dateOfBirth =
                    this.data.patientDetails.dateOfBirth;
            }
            this.patientInformationObject.patientInfo.externalId =
                this.data.patientDetails.externalId || '';
             this.patientInformationObject.patientInfo.gender =
                this.data.patientDetails.birthGender     || '';
            this.patientInformationObject.patientInfo.homePhone =
                this.data.patientDetails.patientHomePhoneNumber;
            this.patientInformationObject.patientInfo.cellPhone =
                this.data.patientDetails.patientPhoneNumber;
            this.patientInformationObject.patientInfo.email =
                this.data.patientDetails.patientEmail;
            this.patientInformationObject.patientInfo.address.addressLine1 =
                this.data.patientDetails.addressLine1;
            this.patientInformationObject.patientInfo.address.addressLine2 =
                this.data.patientDetails.addressLine2;
            this.patientInformationObject.patientInfo.address.city =
                this.data.patientDetails.city;
            this.patientInformationObject.patientInfo.address.postalCode =
                this.data.patientDetails.postalCode;
            this.patientInformationObject.patientInfo.address.stateOrProvinceCode =
                this.data.patientDetails.stateOrProvinceCode;
            this.patientInformationObject.patientInfo.healthPlan =
                this.data.patientDetails.planName;
            this.patientInformationObject.patientInfo.language =
                this.data.patientDetails.preferredLanguage;
            this.patientInformationObject.patientInfo.leadSource =
                this.data.patientDetails.leadSource;
            this.patientInformationObject.patientInfo.callSource =
                this.data.patientDetails.callSource;
        }
        this.getCodeValueByCategoryIdAddressTimezone = this.api
            .getCodeValueByCategoryId(
                reservedCodeCategories.reservedCodeCategoryUnitedStatesTimezoneId,
            )
            .subscribe({
                next: (result: getCodeValueByCategoryIdResult) => {
                    this.addressTimezone = result.data.sort(
                        (
                            a: { valueShortDescription: string },
                            b: { valueShortDescription: string },
                        ) =>
                            a.valueShortDescription.localeCompare(
                                b.valueShortDescription,
                            ),
                    );
                },
                error: (error: HttpErrorResponse) => {
                    console.log('An Error Occurred', error);
                },
            });
        this.localService.broadCastPermissions$.subscribe((value) => {
            const focusBrandConfiguration =
                value?.focusBrandConfiguration?.patientCreationModelConfig ||
                [];
            this.isPatientCreationModelEnabled =
                focusBrandConfiguration?.isConfigEnabled || false;
            if (
                focusBrandConfiguration?.fields &&
                focusBrandConfiguration?.fields.length > 0 &&
                focusBrandConfiguration?.isConfigEnabled
            ) {
                this.patientCreationModelMap = focusBrandConfiguration.fields;
            }
        });

        if (this.data.editPatient) {
            this.data.patientAdditionalFields.columns.forEach((col) => {
                this.formData[col.dataProperty] = this.data
                    .additionalDetailsEmittedValue
                    ? this.data.additionalDetailsEmittedValue[col.dataProperty]
                    : '';
                    if (col.type == 'NUMERIC(PHONE)') {
                        this.formData[col.dataProperty] = this.data
                    .additionalDetailsEmittedValue
                    ? this.data.additionalDetailsEmittedValue[col.dataProperty]?.replace(
                            /^(\+?1)?(\d{3})(\d{3})(\d{4})$/,
                            '+1 $2-$3-$4',
                        )
                    : '';
                    }
                if (col.type == 'DROPDOWN') {
                    if (col.dataProperty == 'timeZone') {
                        this.categoryIds.push(
                            reservedCodeCategories.reservedCodeCategoryUnitedStatesTimezoneId,
                        );
                    } 
                }
            });
        }

        this.categoryIds.push(reservedCodeCategories.reservedCodeCategoryPreferredlanguageId); // language
        this.categoryIds.push(reservedCodeCategories.reservedCodeCategoryPatientLeadSourceId); // lead source
        this.categoryIds.push(reservedCodeCategories.reservedCodeCategoryPatientHealthPlanId); // healthPlan

        this.getCodeValuesByCategory();
    }
    ngOnChanges(): void {
        this.data.stateList = this.data.stateList;
    }

    updatePatientDetails() {
        this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
        this.patientInformationObject.patientInfo.address.stateOrProvinceCode =
            this.patientInformationObject.patientInfo.address
                .stateOrProvinceCode
                ? this.patientInformationObject.patientInfo.address
                      .stateOrProvinceCode
                : '';
        const editPatient = {
            firstName:
                this.patientInformationObject.patientInfo.firstName || '',
            middleName:
                this.patientInformationObject.patientInfo.middleName?.trim() ||
                '',
            lastName: this.patientInformationObject.patientInfo.lastName || '',
            externalId:
                this.patientInformationObject.patientInfo.externalId || '',
            dateOfBirth:
                this.patientInformationObject.patientInfo.dateOfBirth || '',
            cellPhone:
                this.formatPhoneNumber(
                    this.patientInformationObject.patientInfo.cellPhone,
                ) || '',
            homePhone:
                this.formatPhoneNumber(
                    this.patientInformationObject.patientInfo.homePhone,
                ) || '',
            email:
                this.patientInformationObject.patientInfo.email?.trim() || '',
            address: this.patientInformationObject.patientInfo.address,
            additionalDetails: {
                healthPlan:
                    this.patientInformationObject.patientInfo.healthPlan || '',
                language: this.patientInformationObject.patientInfo.language || '',
                leadSource:
                    this.patientInformationObject.patientInfo.leadSource || '',
                callSource:
                    this.patientInformationObject.patientInfo.callSource || '',
                gender: this.patientInformationObject.patientInfo.gender || '',
            },
        };
        if (
            this.data &&
            this.data.patientAdditionalFields &&
            Array.isArray(this.data.patientAdditionalFields.columns)
        ) {
            this.data.patientAdditionalFields.columns.forEach((col) => {
                const colName = col.dataProperty;
                if (colName && this.formData.hasOwnProperty(colName)) {
                    const val = this.formData[colName];
                    if (val !== undefined && val !== null) {
                        if(col.type == "NUMERIC(PHONE)"){
                            (editPatient as any).additionalDetails[colName] = this.formatPhoneNumber(val);
                        }else{
                            (editPatient as any).additionalDetails[colName] = val || '';
                        }
                    }else{
                        (editPatient as any).additionalDetails[colName] = '';
                    }
                }
            });
        }
        if (this.validUpdateRequiredFields()) {
            if (this.data.patientDetails.externalId) {
                if (editPatient.address) {
                    Object.keys(editPatient.address).forEach((key) => {
                        editPatient.address[key] =
                            editPatient.address[key]?.trim() || null;
                    });
                }
                this.loader = true;
                this.createNewPatientService
                    .updatePatientDetails(editPatient, this.data.orgEntityId)
                    .subscribe({
                        next: (result: any) => {
                            this.loader = false;
                            if (result) {
                                this.toastr.success(
                                    'Patient Details updated successfully.',
                                );
                                this.dialogRef.close({ success: true });
                            }
                        },
                        error: (error: any) => {
                            this.loader = false;
                            this.toastr.error(
                                error.error?.message ||
                                    error?.error?.Error ||
                                    'Something went error',
                            );
                        },
                    });
            } else {
                if (
                    this.patientInformationObject.patientInfo &&
                    !this.patientInformationObject.patientInfo.externalId.trim()
                ) {
                    this.toastr.warning(`Please enter external Id`);
                    this.isValid = false;
                } else {
                    this.searchByMRN(
                        {
                            target: {
                                value: this.patientInformationObject.patientInfo.externalId.trim(),
                            },
                        },
                        'save',
                    );
                }
            }
        }
    }

    searchByMRN(event?: any, saveValue?: string) {
        if (this.data.editPatient) {
            if (event) {
                this.patientInformationObject.patientInfo.externalId =
                    event.target.value;
            }
            if (this.patientInformationObject.patientInfo.externalId) {
                this.createNewPatientService
                    .searchByMRN(
                        this.patientInformationObject.patientInfo.externalId,
                    )
                    .subscribe({
                        next: (result: any) => {
                            if (result && result.data) {
                                // let dialogData = {
                                //     newValues: result.data,
                                //     existingValues:
                                //         this.patientInformationObject.patientInfo,
                                //     orgEntityId: this.data.orgEntityId,
                                //     stateList:this.data.stateList
                                // }
                                // const openDialog = () => {
                                //     const dialogRef = this.dialog.open(
                                //         PatientDetailMergeModalComponent,
                                //         {
                                //             disableClose: false,
                                //             data: dialogData,
                                //             width: '1200px',
                                //         },
                                //     )
                                //     dialogRef.afterClosed().subscribe(result => {
                                //         if (result.success) {
                                //             this.dialogRef.close({success: true, orgEntityId: result.orgEntityId});
                                //         }
                                //     });
                                // }

                                // openDialog()
                                this.toastr.warning(
                                    'External Id already exists, please enter another one.',
                                );
                            } else {
                                if (saveValue == 'save') {
                                    this.data.patientDetails.externalId =
                                        event.target.value;
                                    this.updatePatientDetails();
                                } else {
                                    this.toastr.success(
                                        'External ID/MRN does not exist. You can continue with this External Id/MRN.',
                                    );
                                }
                            }
                        },
                        error: (error) => {
                            this.toastr.error(
                                error.error?.message ||
                                    error?.error?.Error ||
                                    'Something went error',
                            );
                        },
                    });
            } else {
                this.toastr.warning(`Please enter External ID/MRN`);
            }
        }
    }

     private validateAdditionalFields(): boolean {
    if (
      !this.data ||
      !this.data.patientAdditionalFields ||
      !this.data.patientAdditionalFields.isAdditionalFieldsEnabled ||
      !Array.isArray(this.data.patientAdditionalFields.columns)
    ) {
      return true;
    }

    for (const col of this.data.patientAdditionalFields.columns) {

      const isReq = col.isRequired === true;
      const prop = col.dataProperty;
      let val: any = undefined;
      if (prop && this.formData && Object.prototype.hasOwnProperty.call(this.formData, prop)) {
        val = this.formData[prop];
      }
      if ((val === undefined || val === null || val === '') && prop) {
        val = (this.patientInformationObject.patientInfo as any)[prop];
      }
      const empty =
        val === undefined ||
        val === null ||
        (typeof val === 'string' && val.trim() === '') ||
        (Array.isArray(val) && val.length === 0);
        const label = col.columnName || prop || 'Field';
      if (empty && isReq && !(prop === 'leadStatus' || prop === 'statusDetail')) {
        this.toastr.warning(`${label} is required.`);
        return false;
      }

       const type = col.type;

            if ( val && prop &&
                (type == 'NUMERIC(PHONE)')
            ) {
                const cleaned = this.cleanPhoneNumber(val as string);
                if (!cleaned || cleaned.length !== 15 || !this.phoneRegex.test(cleaned)) {
                    this.toastr.warning(`${label} is not a valid phone number.`);
                    return false;
                }
            }
            if (val &&  prop &&
                (type == 'ALPHANUMERIC(EMAIL)')
            ) {
                if (typeof val === 'string' && val.length > 0 && !this.emailRegex.test(val)) {
                    this.toastr.warning(`${label} is not a valid email address.`);
                    return false;
                }
            }
    }

    return true;
    }
    validUpdateRequiredFields() {
        this.isValid = true;
        let isLeapYear =
            parseInt(this.dateOfBirthObject.dobYear) % 100 === 0
                ? parseInt(this.dateOfBirthObject.dobYear) % 400 === 0
                : parseInt(this.dateOfBirthObject.dobYear) % 4 === 0;

        if (
            this.patientInformationObject.patientInfo &&
            (!this.patientInformationObject.patientInfo.externalId ||
                !this.patientInformationObject.patientInfo.externalId?.trim())
        ) {
            this.toastr.warning(`Please enter external Id`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            (!this.patientInformationObject.patientInfo.firstName ||
                !this.patientInformationObject.patientInfo.firstName?.trim())
        ) {
            this.toastr.warning(`Please enter First Name`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.firstName.length > 60
        ) {
            this.toastr.warning(`First name should be less than 60 characters`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.middleName.length > 60
        ) {
            this.toastr.warning(
                `Middle name should be less than 60 characters`,
            );
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            (this.patientInformationObject.patientInfo.middleName ||
                this.patientInformationObject.patientInfo.middleName?.trim()) &&
            !this.nameRegex.test(
                this.patientInformationObject.patientInfo.middleName,
            )
        ) {
            this.toastr.warning(`Please enter valid Middle Name`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.lastName.length > 60
        ) {
            this.toastr.warning(`Last name should be less than 60 characters`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            (this.patientInformationObject.patientInfo.firstName ||
                this.patientInformationObject.patientInfo.firstName?.trim()) &&
            !this.nameRegex.test(
                this.patientInformationObject.patientInfo.firstName,
            )
        ) {
            this.toastr.warning(`Please enter valid First Name`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            (!this.patientInformationObject.patientInfo.lastName ||
                !this.patientInformationObject.patientInfo.lastName?.trim())
        ) {
            this.toastr.warning(`Please enter Last Name`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            (this.patientInformationObject.patientInfo.lastName ||
                this.patientInformationObject.patientInfo.lastName?.trim()) &&
            !this.nameRegex.test(
                this.patientInformationObject.patientInfo.lastName,
            )
        ) {
            this.toastr.warning(`Please enter valid Last Name`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.cellPhone &&
            (this.patientInformationObject.patientInfo.cellPhone.length !==
                15 ||
                !this.phoneRegex.test(
                    this.patientInformationObject.patientInfo.cellPhone,
                ))
        ) {
            this.toastr.warning(`Please enter valid cell Number`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            !this.patientInformationObject.patientInfo.cellPhone &&
            (!this.patientInformationObject.patientInfo.email ||
                !this.patientInformationObject.patientInfo.email?.trim())
        ) {
            this.toastr.warning(
                'Either Cell Phone or Email Address is required',
            );
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.homePhone &&
            (this.patientInformationObject.patientInfo.homePhone.length !==
                15 ||
                !this.phoneRegex.test(
                    this.patientInformationObject.patientInfo.homePhone,
                ))
        ) {
            this.toastr.warning(`Please enter valid home Number`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.email &&
            !this.emailRegex.test(
                this.patientInformationObject.patientInfo.email,
            )
        ) {
            this.toastr.warning(`Enter a valid Confidential Email`);
            this.isValid = false;
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.email &&
            this.patientInformationObject.patientInfo.email.trim().length > 100
        ) {
            this.toastr.warning(
                `Email address should be less than 100 characters`,
            );
            this.isValid = false;
        } else if (this.dateOfBirthObject && !this.dateOfBirthObject.dobMonth) {
            this.toastr.warning(`Please enter your  DOB Month`);
            this.isValid = false;
        } else if (this.dateOfBirthObject && !this.dateOfBirthObject.dobDay) {
            this.toastr.warning(`Please enter your  DOB Day`);
            this.isValid = false;
        } else if (this.dateOfBirthObject && !this.dateOfBirthObject.dobYear) {
            this.toastr.warning(`Please enter your  DOB Year`);
            this.isValid = false;
        } else if (
            this.isValid &&
            this.dateOfBirthObject.dobMonth &&
            this.dateOfBirthObject.dobDay &&
            this.dateOfBirthObject.dobYear
        ) {
            if (
                this.dateOfBirthObject.dobMonth < 10 &&
                this.dateOfBirthObject.dobDay >= 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            } else if (
                this.dateOfBirthObject.dobDay < 10 &&
                this.dateOfBirthObject.dobMonth >= 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            } else if (
                this.dateOfBirthObject.dobDay < 10 &&
                this.dateOfBirthObject.dobMonth < 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            } else {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`;
            }
            var date = moment(
                this.patientInformationObject.patientInfo.dateOfBirth,
            );
            if (date.isValid()) {
                var currentDateTime = new Date();
                var expirationDateTime = new Date(
                    this.patientInformationObject.patientInfo.dateOfBirth,
                );
                if (expirationDateTime.getTime() > new Date().getTime()) {
                    this.toastr.warning(
                        "Birth date can't be greater than or equal to the current date",
                    );
                    this.isValid = false;
                } else if (+this.dateOfBirthObject.dobYear < 1900) {
                    this.toastr.warning(
                        'Birth year should be greater than or equal to 1900.',
                    );
                    this.isValid = false;
                } else if (
                    expirationDateTime.getMonth() ===
                        currentDateTime.getMonth() &&
                    expirationDateTime.getFullYear() ===
                        currentDateTime.getFullYear() &&
                    expirationDateTime.getDate() === currentDateTime.getDate()
                ) {
                    this.toastr.warning(
                        "Birth date can't be greater than or equal to the current date",
                    );
                    this.isValid = false;
                } else if (
                    this.dateOfBirthObject.dobMonth.toString() == '02' &&
                    this.dateOfBirthObject.dobDay > 28 &&
                    !isLeapYear
                ) {
                    this.toastr.warning('Invalid birth date');
                    this.isValid = false;
                } else {
                    this.isValid = true;
                }
            } else {
                this.toastr.warning('Date of birth is invalid');
                this.isValid = false;
            }
             if (!this.validateAdditionalFields()) {
                this.isValid = false;
                }
        }
        if (
            this.patientInformationObject.patientInfo?.address?.postalCode &&
            this.patientInformationObject.patientInfo.address.postalCode.trim() !== '' &&
            (
                this.patientInformationObject.patientInfo.address.postalCode.trim().length < 5 ||
                this.patientInformationObject.patientInfo.address.postalCode.trim().length > 5
            )
        ) {
             this.toastr.warning(`Zip Code must be 5 digits`);
            this.isValid = false;
        }

        return this.isValid;
    }
    ngOnDestroy(): void {
        this.getCodeValueByCategoryIdAddressTimezone.unsubscribe();
    }
    hasField(label: string, edit?: string, create?: string) {
        if (edit && this.data.editPatient == true) {
            return true;
        } else if (
            this.patientCreationModelMap &&
            this.patientCreationModelMap.length > 0 &&
            this.data.editPatient == false &&
            this.isPatientCreationModelEnabled == true
        ) {
            return this.patientCreationModelMap.some((f) => f.label === label);
        } else if (this.data.editPatient == false && create &&
            this.isPatientCreationModelEnabled == false){
            return true;
        }else{
            return false;
        }
    }
    isRequired(label: string, edit?: string): boolean {
         if(edit == 'edit' && this.data.editPatient == true){
            return true;
        }else if(edit =='create' && this.data.editPatient == true){
            return false;
        }
        if (
            this.isPatientCreationModelEnabled &&
            this.patientCreationModelMap &&
            this.patientCreationModelMap.length > 0
        ) {
            return this.patientCreationModelMap.some(
                (f) => f.label === label && f.required,
            );
        } 
        return false;
    }
    cleanObject<T extends object>(obj: T): Partial<T> {
        const cleaned: Partial<T> = {};

        Object.keys(obj).forEach((key) => {
            const value = obj[key as keyof T] as unknown;

            if (value && typeof value === 'object') {
                if (Array.isArray(value)) {
                    const filteredArray = value
                        .map((item) =>
                            typeof item === 'object' && item !== null
                                ? this.cleanObject(item as object)
                                : item,
                        )
                        .filter((item) => {
                            if (item === null || item === undefined)
                                return false;
                            if (typeof item === 'string' && item.trim() === '')
                                return false;
                            if (
                                typeof item === 'object' &&
                                Object.keys(item).length === 0
                            )
                                return false;
                            return true;
                        });

                    if (filteredArray.length > 0) {
                        cleaned[key as keyof T] = filteredArray as any;
                    }
                } else {
                    const nested = this.cleanObject(value as object);
                    if (Object.keys(nested).length > 0) {
                        cleaned[key as keyof T] = nested as any;
                    }
                }
            } else if (
                value !== null &&
                value !== undefined &&
                !(typeof value === 'string' && value.trim() === '')
            ) {
                cleaned[key as keyof T] = value as any;
            }
        });

        return cleaned;
    }
    getDropDownList(columnValue: string): string[] {
        if (columnValue === 'leadSource') {
            return this.leadSourceArray;
        } else if (columnValue === 'callSource') {
            return this.callSourceArray;
        } else if (columnValue === 'gender') {
            return this.genderArray;
        } else if (columnValue.toString().toLowerCase().includes('relationship')) {
            return this.relationshipArray;
        } else if (columnValue === 'salutation') {
            return this.salutationArray;
        } else if (columnValue === 'healthPlan') {
            return this.healthPlanArray;
        } else if (columnValue === 'language') {
            return this.languageArray;
        } else if (columnValue === 'timeZone') {
            return this.timezoneArray;
        } else if (columnValue === 'leadStatus') {
            return this.leadStatusArray;
        } else if (columnValue === 'preferredApptReminderMethod') {
            return this.preferredApptReminderMethodArray;
        } else if (columnValue === 'carrierType') {
            return this.carrierTypeArray;
        } else if (columnValue === 'medicarePrescriptionPaymentPlan') {
            return this.medicarePrescriptionPaymentPlanArray;
        }
        return [];
    }

    getCodeValuesByCategory() {
        this.createNewPatientService
            .getCodeValuesByCategory(this.categoryIds)
            .subscribe({
                next: (result: any) => {
                    result.data.forEach((col: any) => {
                        if (col.id == reservedCodeCategories.reservedCodeCategoryPatientLeadSourceId) {
                            this.leadSourceArray = col.codeCategoryValues.map(
                                (item: any) => item.valueShortDescription,
                            );
                        } else if (
                            col.id == reservedCodeCategories.reservedCodeCategoryUnitedStatesTimezoneId
                        ) {
                            this.timezoneArray = col.codeCategoryValues.map(
                                (item: any) => item.valueShortDescription,
                            );
                        } else if (
                            col.id == reservedCodeCategories.reservedCodeCategoryPreferredlanguageId
                        ) {
                            this.languageArray = col.codeCategoryValues.map(
                                (item: any) => item.valueShortDescription,
                            );
                        } else if (
                            col.id == reservedCodeCategories.reservedCodeCategoryPatientHealthPlanId
                        ) {
                            this.healthPlanArray = col.codeCategoryValues.map(
                                (item: any) => item.valueShortDescription,
                            );
                        } 
                    });
                },
                error: (error: HttpErrorResponse) => {
                    console.log('An Error Occurred', error);
                },
            });
    }
}
